import storageService from '../services/storage.js';

/**
 * Redirects to the home page if there are no tests in storage.
 */
export default function requireTestSelection() {
  if (storageService().tests.length > 0) {
    return;
  }

  window.location.replace('/antibiotics');
}
